enum ArticlePath {
    AboutDeposits = '/about-deposits',
    AccountingLedger = '/accounting-ledger',
    AccountingReport = '/accounting-report',
    ActionLog = '/action-log',
    ActivityReport = '/activity-report',
    AgingBalance = '/The-Aging-balance',
    AssignSpacesHousekeepers = '/assign-spaces-to-housekeepers',
    AutoGeneratePoliceReportsAndorra = '/auto-generate-police-reports-for-andorra',
    AutoGeneratePoliceReportsBasqueCountry = '/auto-generate-police-reports-for-the-basque-country',
    AutoGeneratePoliceReportsCzechRepublic = '/auto-generate-police-reports-for-the-czech-republic',
    AutoGeneratePoliceReportsPortugal = '/auto-generate-police-reports-for-portugal',
    AutoGenerateReportsBelgianTouristBoard = '/auto-generate-reports-for-the-belgian-tourist-board',
    AutoGenerateYourSwissTouristReportHesta = '/auto-generate-your-swiss-tourist-report-for-hesta',
    AutomateAvsReportsBasel = '/automate-avs-reports-for-basel',
    AutomateExchangeRateUpdates = '/automate-exchange-rate-updates',
    AutomatePoliceReportsBasel = '/automate-police-reports-for-basel',
    AutomatePoliceReportsSpain = '/automate-police-reports-for-spain',
    AutomatePoliceReportsTicino = '/automate-police-reports-for-ticino',
    AutomatePoliceReportsZug = '/automate-police-reports-for-zug',
    AutomateReportsBasqueFiscalRegistry = '/Automate-reports-for-the-Basque-fiscal-registry',
    AutomateReportsCzechMinistryFinance = '/automate-reports-for-the-czech-ministry-of-finance',
    AutomateReportsGermanFiscalRegistry = '/automate-reports-for-the-german-fiscal-registry',
    AutomateReportsHungarianFiscalRegistry = '/automate-reports-for-the-hungarian-fiscal-registry',
    AutomateReportsIstatItaly = '/automate-reports-for-the-istat-in-italy',
    AutomateReportsIstatLombardy = '/automate-reports-for-the-istat-in-lombardy',
    AutomateReportsItalianFiscalRegistry = '/automate-reports-for-the-italian-fiscal-registry',
    AutomateReportsItalianForeignPolice = '/automate-reports-for-the-italian-foreign-police',
    AutomateReportsSpanishFiscalRegistry = '/automate-reports-for-the-spanish-fiscal-registry',
    AutomaticallyAddQRCodesInvoicesSwitzerland = '/automatically-add-qr-codes-to-invoices-in-switzerland?language=en_US',
    AvailabilityBlockReport = '/Availability-block-report',
    AvailabilityOccupancyReport = '/Availability-Occupancy-report',
    BillInvoiceNumberingWithCounters = '/set-bill-and-invoice-numbering-with-counters',
    BillsInvoicesReport = '/bills-and-invoices-report',
    BookableService = '/set-up-a-bookable-service',
    BookingComTaxWithholding = '/Understanding-Booking-com-tax-withholding-changes',
    CardDataRetentionPolicy = '/Configuring-your-card-data-retention-policy',
    ChangeReservationDetails = '/change-the-reservation-details',
    ChangeYourUserAccountInformation = '/How-to-change-your-Mews-user-account-information',
    ChannelManagerQueue = '/channel-manager-queue',
    ChargebackReport = '/chargeback-report',
    CheckoutReport = '/check-out-report',
    CityLedger = '/The-City-ledger',
    CityTaxReport = '/city-tax-report',
    ConfiguringAgeCategories = '/Configuring-age-categories-in-Mews',
    ConfiguringPricingDetailsProduct = '/Configuring-the-pricing-details-of-a-product',
    ConnectChannelManager = '/connect-your-channel-manager',
    ConnectDisconnectIntegrations = '/connect-and-disconnect-integrations',
    CorrectingClosedBill = '/new-billing-procedure-correct-a-closed-bill',
    CreateAccountingCategory = '/create-an-accounting-category',
    CreateCompanyProfile = '/create-a-company-profile',
    CreateDeleteAdditionalService = '/create-or-delete-an-additional-service',
    CreateDeleteCashier = '/create-or-delete-a-cashier',
    CreateDeleteEmployeeProfile = '/create-or-delete-an-employee-profile',
    CreateDeleteProduct = '/create-or-delete-a-product',
    CreateDeleteSpaceCategory = '/create-or-delete-a-space-category',
    CreateManageTasks = '/create-and-manage-tasks',
    CreateModifyDeleteCalendarEvent = '/create-modify-or-delete-a-calendar-event',
    CreateModifyDeleteCancellationPolicy = '/create-modify-or-delete-a-cancellation-policy',
    CreateModifyDeleteCustomLink = '/create-modify-or-delete-a-custom-link',
    CreateModifyDeleteDepartment = '/create-modify-or-delete-a-department',
    CreateModifyDeleteRateGroup = '/create-modify-or-delete-a-rate-group',
    CreateModifyDeleteSegment = '/create-modify-or-delete-a-segment',
    CreateModifyDeleteSpace = '/create-modify-or-delete-a-space',
    CreateModifyDeleteSpaceFeature = '/create-modify-or-delete-a-space-feature',
    CreatePasskey = '/How-to-create-passkeys-for-your-Mews-account',
    CreateRate = '/create-a-rate',
    CreateReservation = '/create-a-reservation',
    CreateVoucher = '/create-a-voucher',
    CreatingAvailabilityAdjustments = '/Creating-availability-adjustments',
    CreatingAvailabilityBlocks = '/Creating-availability-blocks-in-Mews',
    CreditNoteCounters = '/How-to-create-bill-counters-for-bills-invoices-and-credit-notes-in-Mews-Operations',
    CustomerProfilesReport = '/customer-profiles-report',
    CustomerStatisticsReport = '/customer-statistics-report',
    CustomizeYourEmails = '/customize-your-emails',
    DepositLedger = '/Deposit-ledger',
    DeviceCommandsQueue = '/device-commands-queue',
    ExportsQueue = '/exports-queue',
    FinancialAnalytics = '/financial-analytics',
    FiscalRecordReport = '/fiscal-record-report',
    GroupBilling = '/get-to-know-group-billing',
    GuestFacingDocuments = '/how-to-set-up-guest-facing-documents',
    GuestJourneyInBookingEngine = '/what-does-the-guest-journey-look-like-in-the-mews-booking-engine',
    GuestLedger = '/Guest-ledger',
    GuestsHouseReport = '/guests-in-house-report',
    HowCutterIntegrationsWork = '/how-do-key-cutter-integrations-work',
    HowToChangeTheOwnerOfABill = '/How-to-change-the-owner-of-a-bill',
    HowToConfigureMultipleSettlementRules = '/Using-multiple-settlement-rules-in-Mews?language=en_US#How-to-configure-multiple-settlement-rules',
    HowToCreateBillingAutomation = '/How-to-create-a-billing-automation-in-Mews-Operations',
    HowToCreateMmpCancellationPolicy = '/How-to-create-a-cancellation-policy-in-Mews-Multi-Property',
    HowToCreateMmpPaymentPolicy = '/How-to-create-a-payment-policy-in-Mews-Multi-Property',
    HowToCreateRestrictions = '/How-to-create-restrictions-in-Mews-Operations',
    HowToDeleteProductsInMewsMultiProperty = '/How-to-delete-products-in-Mews-Multi-Property',
    HowToEditAndDeleteRestrictions = '/How-to-edit-and-delete-restrictions-in-Mews-Operations',
    HowToGenerateSwedishCashRegisterReports = '/How-to-generate-Swedish-Cash-Register-Reports-in-Mews-Operations',
    HowToLinkPaymentToReservation = '/How-to-link-a-payment-to-a-reservation-in-Mews-Operations',
    HowToSetUpPaymentAutomation = '/how-to-set-up-payment-automation',
    HowToSetUpSwedishCashRegisterIntegration = '/How-to-set-up-the-Swedish-cash-register-integration-in-Mews-Operations',
    ImportFutureReservations = '/import-future-reservations',
    ImportHistoricalData = '/import-historical-data-with-mews-analytics',
    IncorrectPaymentAndCancellationPoliciesDisplay = '/Resolving-incorrect-payment-and-cancellation-policies-display-in-Mews-Operations',
    Insights = '/insights',
    InventoryUpdatesQueue = '/inventory-updates-queue',
    IstatReportPisaProvinceTuscanyRegionServiceIntegration = '/istat-report-for-the-pisa-province-in-tuscany-region-a-web-service-integration',
    Ledgers = '/The-Ledgers-screen-in-Mews-Operations',
    MailQueue = '/mail-queue',
    ManagerAnalytics = '/manager-analytics',
    ManagerReport = '/manager-report',
    ManagingRestrictions = '/managing-restrictions',
    MergeCustomerProfiles = '/How-to-merge-matching-customer-profiles-with-Match-and-merge-in-Mews-Operations',
    MewsMerchantBalanceReport = '/mews-merchant-balance-report',
    MfaExceptions = '/How-to-create-a-two-factor-authentication-2FA-exemption-list',
    ModifyEmployeeProfile = '/modify-an-employee-profile',
    ModifyProductCategory = '/modify-a-product-category',
    MultiPropertyAvailability = '/The-Availability-occupancy-report-in-Mews-Multi-Property',
    MulticurrencyByMewsPaymentsFAQ = '/Multicurrency-by-Mews-Payments-FAQ',
    NumberFormatForCounters = '/Track-and-retrieve-invoices-by-their-titles-using-number-formats-for-counters',
    OccupancyReport = '/occupancy-report',
    OpenCloseCashierShift = '/open-or-close-a-cashier-shift',
    OpenPayoutDetail = '/Understanding-the-Open-balance-detail-screen-in-the-Payout-report',
    OptimizeSpaceAllocation = '/optimize-space-allocation-on-the-timeline?language=en_US',
    OutletAnalytics = '/outlet-analytics',
    Outlets = '/set-up-outlets',
    OverviewPortfolioSettings = '/Overview-of-portfolio-settings-in-Mews-Multi-Property',
    PackageProductsWithAccommodation = '/package-products-with-accommodation',
    PaymentCardReport = '/payment-card-report',
    PaymentReport = '/payment-report',
    PayoutReport = '/The-Payout-report',
    PayoutReportDetail = '/The-Payout-detail-screen',
    PickingUpReservationsInAvailabilityBlocks = '/Picking-up-reservations-in-availability-blocks',
    PickupAnalytics = '/pickup-analytics',
    PortfolioRateGroupCreation = '/How-to-create-rate-groups-in-Mews-Multi-Property',
    PostPettyCashTransactions = '/post-petty-cash-transactions',
    PostingJournal = '/posting-journal',
    ProcessCancelOrder = '/process-or-cancel-an-order',
    ProductChecklist = '/the-product-checklist',
    ProductReport = '/product-report',
    PromoteOtherBookableServices = '/Promote-other-bookable-services-along-with-stay',
    RateManagement = '/rate-management',
    RateManagementPortfolio = '/rate-Management-in-your-portfolio-account',
    ReadReplyMessages = '/read-and-reply-to-messages',
    RegistrationCards = '/how-do-i-set-up-registration-cards',
    ReservationInstallationQueue = '/reservation-installation-queue',
    ReservationOverview = '/reservation-overview',
    ReservationReport = '/reservation-report',
    RouteProductsCompanyBills = '/route-products-to-company-bills',
    SMSPackageFaq = '/SMS-Package-FAQs',
    SMSPackageForMewsOperations = '/SMS-Package-for-Mews-Operations',
    ScanIdentityDocument = '/scan-an-identity-document',
    ScheduleReportExports = '/schedule-report-exports',
    SecurityOverview = '/Securing-your-Mews-Operations-user-accounts',
    SetUpAndCustomizeRolesMultiProperty = '/Set-up-and-customize-roles-in-Mews-Multi-Property',
    SetUpAndCustomizeUserRoles = '/Set-up-and-customize-user-roles',
    SetUpAndCustomizeUsersMultiProperty = '/Set-up-and-customize-users-in-Mews-Multi-Property',
    SetUpBookingEngine = '/set-up-your-mews-booking-engine',
    SetUpExchangeRates = '/set-up-your-exchange-rates',
    SetUpPortfolio = '/How-to-set-up-your-portfolio-using-Mews-Multi-Property',
    SetUpPropertyAccount = '/set-up-your-property-account',
    SetUpPropertyGroups = '/How-to-create-Property-groups-in-Mews-Multi-Property',
    SetUpScimUserProvisioning = '/How-to-set-up-System-for-Cross-Domain-Identity-Management-SCIM-user-provisioning-in-Mews',
    SettingUpYourAccount = '/setting-up-your-account',
    SpaceStatusReport = '/space-status-report',
    TakePayment = '/take-a-payment',
    TextMessageQueue = '/The-Text-message-queue',
    TheManagerReport = '/The-Manager-report',
    TimeSpentReport = '/time-spent-report',
    Timeline = '/timeline',
    TravelAgencies = '/set-up-travel-agencies',
    TrustedDeviceAuthorization = '/How-to-add-a-new-trusted-device-with-Trusted-Device-Authorization-in-Mews-Operations-1',
    UnderstandingServices = '/understanding-services',
    UnderstandingUsersRoles = '/Understanding-users-and-role-management-in-Mews-Multi-Property',
    UpdateDeleteCustomerProfile = '/update-or-delete-a-customer-profile',
    UpdateRemoveRate = '/update-or-remove-a-rate',
    UserGroupsDetailPanel = '/Managing-user-groups-in-Mews-for-System-for-Cross-Domain-Identity-Management-SCIM',
    UserGroupsListIndex = '/How-to-set-up-user-groups-in-your-IdP-for-System-for-Cross-Domain-Identity-Management-SCIM-in-Mews',
    VoucherManagement = '/Vouchers-in-your-portfolio-account',
    WhatIsAccountingConfiguration = '/what-is-the-accounting-configuration',
    WhatIsAnalytics = '/what-is-mews-analytics',
    WhatReservationModuleWhatFeatures = '/what-is-the-reservation-module-and-what-are-its-features',
    YourMewsKiosk = '/Setting-up-your-Mews-Kiosk',
}

export const createGuideLink = (articlePath: ArticlePath) => `https://help.mews.com/s/article${articlePath}`;

export default ArticlePath;
